import mixpanel from 'mixpanel-browser';

import { environments } from '../constants';

mixpanel.init(environments.MIXPANEL_PROJECT_TOKEN);

const isEnabled = environments.REACT_APP_DEPLOY_STAGE !== 'test';

interface MixpanelProps {
  [key: string]: string | number | boolean | Date;
}

interface MixpanelService {
  identify: (id: string) => void;
  alias: (id: string) => void;
  track: (name: string, props?: MixpanelProps) => void;
  people: {
    set: (props: MixpanelProps) => void;
    set_once: (name: string, props: MixpanelProps) => void;
  };
  register: (props: MixpanelProps) => void;
}

const mixpanelService: MixpanelService = {
  identify: (id) => {
    if (isEnabled && id !== undefined) {
      mixpanel.identify(id);
    }
  },
  alias: (id) => {
    if (isEnabled) {
      mixpanel.alias(id);
    }
  },
  track: (name, props) => {
    if (isEnabled) {
      mixpanel.track(name, props);
    }
  },
  people: {
    set: (props) => {
      if (isEnabled) {
        mixpanel.people.set(props);
      }
    },
    set_once: (_name, props) => {
      if (isEnabled) {
        mixpanel.people.set_once(props);
      }
    },
  },
  register: (props) => {
    if (isEnabled) {
      mixpanel.register(props);
    }
  },
};

export default mixpanelService;
